import React from 'react';

const StepCounter = ({ hops }) => (
  <div className="flex items-center gap-1.5">
    <span className="text-[#888] text-xs font-semibold uppercase tracking-wider">Hops</span>
    <span className="bg-[#ff6b35] text-white text-base font-black px-2.5 py-0.5 rounded-md border-2 border-white min-w-[28px] text-center">
      {hops}
    </span>
  </div>
);

export default StepCounter;
